export const PINK = {
  LIGHTER: '#F3E8F2',
} as const;
